import { Checkbox, DatePicker, Textarea, Select } from "components/form-inputs/inputs";
import React, { useMemo, useState } from "react";
import * as notify from "shared/notify";

export const NewMessageForm = ({ onSubmit }) => {
    const [formState, setFormState] = useState({
        isActive: false,
    });
    const messageGroups = useMemo(
        () => [
            { text: "-- Select --", value: "" },
            { text: "Measuring", value: "Measuring" },
            { text: "Photography", value: "Photography" },
            { text: "Scheduling", value: "Scheduling" },
            { text: "Coding", value: "Coding" },
            { text: "CodingQA", value: "CodingQA" },
            { text: "ImageEditing", value: "ImageEditing" },
            { text: "ImageEditingQA", value: "ImageEditingQA" },
            { text: "BinMover", value: "BinMover" },
            { text: "FinalQA", value: "FinalQA" },
        ],
        []
    );

    const updateSimpleField = (e) => {
        const { name, value } = e.target;

        setFormState((prevFormState) => ({ ...prevFormState, [name]: value }));
    };

    const updateCustomField = (name, date) => {
        setFormState((prevFormState) => ({ ...prevFormState, [name]: date }));
    };

    const validate = () => {
        const { message, startDate, endDate } = formState;

        if (!message) {
            return notify.error("Message can't be empty");
        }

        if (!startDate || !endDate) {
            return notify.error("Start date/end date must be set");
        }

        if (startDate > endDate) {
            return notify.error("Start date can't be higher than end date");
        }

        onSubmit(formState);
        setFormState({ isActive: false });
    };

    return (
        <>
            <Textarea name="message" label="Message" value={formState["message"]} onChange={updateSimpleField} />
            <Checkbox label="Active" name="isActive" value={formState["isActive"]} updateOnChange={updateCustomField} />
            <DatePicker
                showTimeSelect
                label="Start date"
                name="startDate"
                value={formState["startDate"]}
                updateOnChange={updateCustomField}
                enableIcon
            />
            <DatePicker showTimeSelect label="End date" name="endDate" value={formState["endDate"]} updateOnChange={updateCustomField} enableIcon />
            <Select
                label="Message group"
                name="messageGroup"
                onChange={updateSimpleField}
                value={formState["messageGroup"] || ""}
                excludeSelect={true}
                options={messageGroups}
            />
            <div className="button-group -right">
                <button className="button -primary" onClick={validate}>
                    Add New Message
                </button>
            </div>
        </>
    );
};
